import {
  FirebaseOptions,
  getApps,
  initializeApp,
} from 'firebase/app';
import { getAuth } from 'firebase/auth';

export const getIsolatedAuth = (
  appName: string,
  config: FirebaseOptions,
) => {
  const app =
    getApps().find((firebaseApp) => firebaseApp.name === appName) ||
    initializeApp(config, appName);
  return getAuth(app);
};
